(() => {
  function initProductPage(scope = document) {
    const sections = scope.matches?.('[data-digital-product]') ? [scope] : scope.querySelectorAll('[data-digital-product]');
    sections.forEach(section => {
      if (section.dataset.pageEnhanced) return;
      section.dataset.pageEnhanced = 'true';
      const controller = new AbortController();
      const options = {signal: controller.signal};
      const form = section.querySelector('[data-product-form]');
      const select = section.querySelector('[data-variant-select]');
      const saleBadge = section.querySelector('[data-sale-badge]');
      const stickyPrice = section.querySelector('[data-sticky-price]');
      let variants = [];
      try { variants = JSON.parse(section.querySelector('[data-variants]')?.textContent || '[]'); } catch {}
      const updatePrice = () => {
        const variant = variants.find(item => String(item.id) === form?.querySelector('[name="id"]')?.value);
        if (!variant) return;
        if (saleBadge) {
          const onSale = variant.compare_at_price > variant.price;
          saleBadge.hidden = !onSale;
          saleBadge.textContent = onSale ? saleBadge.dataset.saleTemplate.replace('__PERCENT__', String(Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price))) : '';
        }
        if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
        section.dispatchEvent(new Event('product:price-change', {bubbles: true}));
      };
      select?.addEventListener('change', updatePrice, options);
      const thumbnails = Array.from(section.querySelectorAll('[data-media-target]'));
      thumbnails.forEach((button, index) => {
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % thumbnails.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + thumbnails.length) % thumbnails.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = thumbnails.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          thumbnails[next].focus({preventScroll: true});
          thumbnails[next].click();
          thumbnails[next].scrollIntoView({block: 'nearest', inline: 'nearest'});
        }, options);
      });
      const sticky = section.querySelector('.product-sticky');
      const primary = section.querySelector('[data-add-to-cart]');
      const footer = document.querySelector('.site-footer');
      let frame;
      const updateSticky = () => {
        frame = undefined;
        if (!sticky || !primary) return;
        const primaryAbove = primary.getBoundingClientRect().bottom < 0;
        const beforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight + sticky.offsetHeight;
        sticky.dataset.visible = String(primaryAbove && beforeFooter);
      };
      const scheduleSticky = () => {if (!frame) frame = requestAnimationFrame(updateSticky);};
      if (sticky && primary) {
        window.addEventListener('scroll', scheduleSticky, {...options, passive: true});
        window.addEventListener('resize', scheduleSticky, options);
        section.addEventListener('toggle', scheduleSticky, {...options, capture: true});
        updateSticky();
      }
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(section)) {controller.abort(); if (frame) cancelAnimationFrame(frame);}
      }, options);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initProductPage(), {once: true});
  else initProductPage();
  document.addEventListener('shopify:section:load', event => initProductPage(event.target));
})();

